import { render, staticRenderFns } from "./MdtSelect.vue?vue&type=template&id=246dd85a&scoped=true"
import script from "./MdtSelect.vue?vue&type=script&lang=js"
export * from "./MdtSelect.vue?vue&type=script&lang=js"
import style0 from "./MdtSelect.vue?vue&type=style&index=0&id=246dd85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246dd85a",
  null
  
)

export default component.exports